<template>
  <div id="app">
    <Loader v-if="$store.state.formSubmitLoading" />
    <nav class="navbar navbar-light bg-white mb-5">
      <div class="container justify-content-center justify-content-md-between">
        <a class="navbar-brand" href="#">
          <img class="w-100" :src="'./assets/colonnade_logo.png'" alt="Colonnade logo" />
        </a>
      </div>
    </nav>
    <!-- <div v-if="merchant_id === 'colo213'">
      <div class="alert alert-light text-center mb-4">
        <div class="h5 m-0" style="color: red;">
          A Colonnade szállítmánybiztosítás csak értékesítőn keresztül köthető. Kérem, keresse fel
          biztosításközvetítőjét.
        </div>
      </div>
    </div> -->
    <div class="container">
      <div class="mb-3 ms-md-auto flex-grow-1 w-100 w-md-auto flex-md-grow-0 connection">
        {{ $store.state.connection }}
        <div v-if="datas.product_code">
          {{ ' Kalkuláció azonosítója:' + datas.product_code }}
        </div>
      </div>
      <NavigationTop />
      <div class="alert alert-light text-center mb-4">
        <p v-if="$store.state.page == 1" class="h5 m-0">
          Köszöntjük a Colonnade Biztosító Szállítmánybiztosítás tarifáló oldalán!<br /><br />
        </p>
        <p v-else-if="$store.state.page == 2" class="h5 m-0">
          Kérjük, adja meg a szerződő és a biztosított adatait!
        </p>
        <p v-else-if="$store.state.page == 3" class="h5 m-0">
          Kérjük, ellenőrizze az alábbi összesítést, és győződjön meg a korábban megadott adatok
          helyességéről! Ha mindent rendben talált, az oldal alján található nyilatkozatok
          elfogadásával véglegesítheti a biztosítási szerződést.
        </p>
      </div>
      <h2 class="text-danger mb-2" v-if="$store.state.generalErrors.length > 0">Hibák</h2>
      <ul class="text-danger mb-5" v-if="$store.state.generalErrors.length > 0">
        <li v-for="(error, key) in $store.state.generalErrors" :key="`gerror-${key}`">
          {{ error }}
        </li>
      </ul>
      <OverallData v-if="$store.state.page > 1 && $store.state.page < 5" />
      <ValidationObserver v-slot="{invalid, validate}">
        <form id="form">
          <GeneralPage v-if="$store.state.page >= 1" v-show="$store.state.page === 1" />
          <ContractPage v-if="$store.state.page >= 2" v-show="$store.state.page === 2" />
          <SummaryPage v-if="$store.state.page >= 3" v-show="$store.state.page === 3" />
        </form>
        <Navigation :invalid="invalid" :validate="validate" />
        <p v-show="invalid" class="h6 mb-3 text-center text-md-end text-danger" id="invalid_inputs">
          Kérjük töltse ki a csillaggal (*) megjelölt mezőket.
        </p>
        <p v-if="$store.state.page === 5" class="text-justify">
          A fenti gomb megnyomásával kijelentem, hogy jelen ajánlatban részletezett feltételekkel
          ajánlatot teszek a Colonnade Minősített Fogyasztóbarát Otthonbiztosítás szerződés
          megkötésére a Colonnade Insurance S.A. Magyarországi Fióktelepe részére. Kijelentem, hogy
          a jelen Biztosítási ajánlatban feltüntetett adatok a valóságnak megfelelnek, a valótlan
          adatok közlése pedig a biztosítási szerződés érvénytelenségét vonja maga után. A létrejött
          Biztosítási szerződés alapján a Biztosító díjfizetés ellenében arra vállal
          kötelezettséget, hogy a Colonnade Minősített Fogyasztóbarát Otthonbiztosítás biztosítási
          feltételeiben meghatározott kockázatokra fedezetet nyújt és a biztosítási feltételekben
          meghatározott biztosítási esemény bekövetkezése esetén a vonatkozó biztosítási
          feltételekben meghatározott szolgáltatást nyújtja.
        </p>
      </ValidationObserver>
    </div>
    <Footer />
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';

import GeneralPage from './components/GeneralPage';
import ContractPage from './components/ContractPage';
import SummaryPage from './components/SummaryPage';
import NavigationTop from './NavigationTop';
import OverallData from './OverallData';
import Navigation from './Navigation';
import Footer from './Footer';
import Loader from './components/Loader';

import {debounce} from 'debounce';
import jQuery from 'jquery';

export default {
  components: {
    GeneralPage,
    ContractPage,
    SummaryPage,
    Navigation,
    NavigationTop,
    Footer,
    OverallData,
    Loader,
  },
  computed: {
    ...mapGetters({
      datas: 'getAllState',
    }),
    ...mapFields(['merchant_id']),
  },
  methods: {
    ...mapActions(['verifyPage', 'getMarks', 'getSelectLists']),
  },
  mounted() {
    localStorage.removeItem('storage_uid');
    jQuery(document).on('select2:open', () => {
      document.querySelector('.select2-search__field').focus();
    });
  },
  created() {
    localStorage.removeItem('storage_uid');
    localStorage.removeItem('last_interaction');
    this.getSelectLists();
    this.getMarks();

    const search_params = window.location.search.substring(1).split('&');
    search_params.forEach((param) => {
      const [key, value] = param.split('=');
      if (key == 'merchant_id' && value) this.merchant_id = value;
    });

    this.verifyPage();
  },
  watch: {
    datas: {
      handler: debounce(function(after, before) {
        if (this.$store.state.page !== 1) return;
        this.verifyPage();
      }, 3000),
      deep: true,
    },
  },
};
</script>

<style lang="scss">
$red: #e4002b;

html {
  scroll-behavior: smooth;
}

body {
  color: #555 !important;
  font-size: 14px !important;
  font-family: Arial, Helvetica, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.input-group-text {
  border-radius: 0.25rem 0 0 0.25rem !important;
}

.input-group-append .input-group-text {
  border-radius: 0 0.25rem 0.25rem 0 !important;
}

.form-check-input {
  width: 17px !important;
  height: 17px !important;
  margin-top: 0.125em !important;
  margin-right: 0.5em;
}

label,
.label {
  margin-bottom: 3px;
  font-size: 14px;

  &.col-sm-4 {
    font-weight: bold !important;
  }
}

span.info {
  text-align: center;
  display: inline-block;
  background-color: $red;
  border-radius: 50%;
  color: white;
  max-width: 21px;
  max-height: 21px;
  width: 21px;
  height: 21px;
  line-height: 21px;
  cursor: pointer;
  user-select: none;
  font-size: 14px;
  font-weight: bold;
}

h1,
h2 {
  color: $red;
  text-transform: uppercase;
  font-weight: 600 !important;
  margin: 0 0 30px !important;
  line-height: 140%;
}

h1 {
  font-size: 20px !important;
}

h2,
.h2 {
  font-size: 17px !important;
}

.datepicker > button {
  background-color: $red !important;
  border-color: $red !important;

  &:hover,
  &:focus,
  &:active {
    background-color: $red !important;
    border-color: $red !important;
  }
}

.btn-red {
  background-color: $red !important;
  color: white !important;
  font-size: 14px !important;
  padding: 8px 10px !important;
}

.btn-outline-danger {
  color: $red !important;
  border-color: $red !important;
  font-size: 14px !important;
  padding: 8px 10px !important;

  &:hover,
  &:active,
  &:focus {
    background-color: $red !important;
    color: white !important;
  }
}

.alert-dark {
  background-color: #6c757d !important;
  color: white !important;
}

.alert-light {
  color: #555 !important;
}

.datepicker-prepend-input {
  flex-grow: 1;

  input {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    flex-grow: 1;
  }
}

.swal2-close:focus {
  box-shadow: none;
}

.swal2-icon {
  color: #ced4da !important;
  border-color: #ced4da !important;
}

::selection {
  color: white;
  background: #333;
  text-shadow: none;
}

.connection {
  color: #797f838f;
}
</style>
